import Button from 'components/Form/Button';
import FormCore from 'components/Form/Core';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import 'jspdf-autotable';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { GET } from 'services/api';
import { Title } from 'ui/styled';
import { formatDocuments, formatPhone, parseCurrency } from 'utils/parsers';
import {
  FinancingProposalFormsWrapper,
  FinancingProposalHeader,
} from './styled';

export default function FinancingProposal2() {
  const { id } = useParams();
  const history = useHistory();
  const { user } = useContext(CoreContext);
  const [loading, setLoading] = useState(true);
  const [cliente, setCliente] = useState({});
  const [endereco, setEndereco] = useState({});
  const [financeiro, setFinanceiro] = useState({});
  const [identificacao, setIdentificacao] = useState({});
  const init = useCallback(async () => {
    try {
      const response = await GET(`/pre-proposals/${id}?populate=*`, true);
      const data =
        response?.data?.data?.attributes ||
        response?.data?.attributes ||
        response?.data ||
        response;
      // Identificação
      setIdentificacao({
        distribuidor:
          user?.administrador && data.distribuidor
            ? data.distribuidor.trade_name ||
              data.distribuidor.nome ||
              'Não informado'
            : 'N/A',
        cnpj_integrador: data.cnpj_integrador || 'N/A',
        telefone_vendedor: formatPhone(
          data.ddd_vendedor,
          data.telefone_vendedor
        ),
        nome_vendedor: data.nome_vendedor || 'N/A',
      });
      // Cliente
      setCliente({
        tcc2: data.tipo_cliente === 'fisica' ? 'Física' : 'Jurídica',
        cpf_cnpj: formatDocuments(data.cpf || data.cnpj),
        nome_completo: data.nome_completo || 'N/A',
        //seta a data de nascimento no formato DD/MM/AAAA, alterado para permitir copiar o campo, antes era type date
        data_nascimento: data.data_nascimento
          ? (() => {
              const [ano, mes, dia] = data.data_nascimento.split('-');
              return `${dia}/${mes}/${ano}`;
            })()
          : 'N/A',
        valor_financiamento: parseCurrency(data.valor_financiamento),
        celular: formatPhone(data.ddd, data.celular),
        email: data.email || 'N/A',
      });
      setEndereco({
        cep: data.cep || 'N/A',
        logradouro: data.logradouro || 'N/A',
        numero: data.numero || 'N/A',
        complemento: data.complemento || 'N/A',
        bairro: data.bairro || 'N/A',
        cidade: data.cidade || 'N/A',
        uf: data.uf || 'N/A',
      });

      setLoading(false);
    } catch (err) {
      console.error('Erro ao carregar pré-proposta:', err);
      setLoading(false);
    }
  }, [id, user]);

  useEffect(() => init(), [init]);

  if (loading) {
    return (
      <ContainerAuthenticated>
        <Title>Carregando...</Title>
      </ContainerAuthenticated>
    );
  }

  return (
    <ContainerAuthenticated>
      <Title>Espelho da Pré-Proposta {id}</Title>
      <div
        style={{
          margin: '16px 0',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 12,
        }}
      />
      <FinancingProposalFormsWrapper>
        {/* IDENTIFICAÇÃO */}
        <FinancingProposalHeader>
          <Title small>Identificação</Title>
          <Button
            color="blue"
            width={'fit-content'}
            small
            nospace
            onClick={() => history.goBack()}
          >
            Voltar
          </Button>
        </FinancingProposalHeader>
        <FormCore
          register={identificacao}
          readOnly
          formItems={[
            {
              ref: 'distribuidor',
              placeholder: 'Distribuidor',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'cnpj_integrador',
              placeholder: 'CNPJ Integrador',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'telefone_vendedor',
              placeholder: 'Telefone Vendedor',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'nome_vendedor',
              placeholder: 'Nome Vendedor',
              disabled: true,
              transparent: false,
            },
          ]}
        />
        {/* CLIENTE */}
        <FinancingProposalHeader>
          <Title small>Informações do Cliente</Title>
        </FinancingProposalHeader>
        <FormCore
          register={cliente}
          readOnly
          formItems={[
            {
              ref: 'tcc2',
              placeholder: 'Tipo de Pessoa',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'cpf_cnpj',
              placeholder: 'CPF / CNPJ',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'nome_completo',
              placeholder: 'Nome Completo',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'data_nascimento',
              placeholder: 'Data de Nascimento',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'valor_financiamento',
              placeholder: 'Valor do Financiamento',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'celular',
              placeholder: 'Celular',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'email',
              placeholder: 'E-mail',
              disabled: true,
              transparent: false,
            },
          ]}
        />
        {/* ENDEREÇO */}
        <FinancingProposalHeader>
          <Title small>Endereço</Title>
        </FinancingProposalHeader>
        <FormCore
          register={endereco}
          readOnly
          formItems={[
            {
              ref: 'cep',
              placeholder: 'CEP',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'logradouro',
              placeholder: 'Logradouro',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'numero',
              placeholder: 'Número',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'complemento',
              placeholder: 'Complemento',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'bairro',
              placeholder: 'Bairro',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'cidade',
              placeholder: 'Cidade',
              disabled: true,
              transparent: false,
            },
            {
              ref: 'uf',
              placeholder: 'UF',
              disabled: true,
              transparent: false,
            },
          ]}
        />
      </FinancingProposalFormsWrapper>
    </ContainerAuthenticated>
  );
}
